import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  margin-bottom: 24px;
  position: relative;

  .manage-filters {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    transition: 0.2s ease;
    cursor: pointer;
    width: calc(100% - 45px - 8px);

    padding: 8px 0px;
    border-radius: 8px;
    font-weight: bold;
    color: var(--black-7);
    background: transparent;

    :hover {
      background: var(--white-darker);
    }

    > svg {
      margin-right: 8px;
    }

    > span {
      margin-left: 10px;
      font-weight: normal;
      text-align: left;
      width: 100%;
      max-width: 100%;
      /*
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; */
    }
  }

  .clear-filters {
    display: grid;
    place-items: center;
    cursor: pointer;
    color: var(--black-7);
    border-radius: 8px;
    background: transparent;
    transition: 0.2s ease;

    height: 40px;
    width: 40px;

    :hover {
      color: var(--danger);
      background: var(--danger-transparent);
    }
  }
`;
